<template>
  <div class="group-member">
    <div v-if="action" class="group-member-header">
        <yxt-button type="primary" @click="addUser">{{$t('pc_biz_ote_lbl_addstudent' /* 添加学员 */)}}</yxt-button>
    </div>
    <div :class="{
      'group-member-content': true,
      'group-member-content--full': !action
    }">
        <div :class="{
          'group-member-content-list': true,
          'group-member-content-list--full': !action || memberList.length < 20
        }">
            <yxt-table
                ref="refTable"
                height="100%"
                selected-row-by-key="isSelected"
                :data="memberTableList"
                @select="handleSelectionChange"
                @select-all="handleSelectionChange"
            >
                <yxt-table-column
                    width="18"
                    hide-column="disable"
                    clear-padding="left-right"
                    align="right"
                >
                    <template slot-scope="scope">
                        <input class="drag-value" type="hidden" :value="scope.row.userId"/>
                        <img class="group-member-content-list__drag" src="../../../assets/drag_icon.png" />
                    </template>
                </yxt-table-column>
                <yxt-table-column
                    type="selection"
                    width="20"
                    align="right"
                    clear-padding="left-right"
                ></yxt-table-column>
                <yxt-table-column
                    prop="username"
                    popover-html
                    :label="$t('pc_biz_ote_lbl_cnname' /* 姓名 */)"
                    align="left"
                >
                  <template slot-scope="scope">
                    <tooltip-content :content="scope.row.fullname" :leader="!!(scope.row.leader && groupId)" >
                      <yxtbiz-user-name :name="scope.row.fullname || '--'"></yxtbiz-user-name>
                    </tooltip-content>
                  </template>
                </yxt-table-column>
                <yxt-table-column
                    :label="$t('pc_biz_ote_lbl_department' /*部门*/)"
                    prop="deptName"
                >
                  <template slot-scope="scope">
                    <tooltip-content :content="scope.row.deptName" >
                      <yxtbiz-dept-name :name="scope.row.deptName || '--'"></yxtbiz-dept-name>
                    </tooltip-content>
                  </template>
                </yxt-table-column>
                <yxt-table-column
                    :label="$t('pc_biz_ote_lbl_position' /* 岗位 */)"
                    prop="positionName"
                >
                  <template slot-scope="scope">
                    <tooltip-content :content="scope.row.positionName" >
                      <span>{{scope.row.positionName || '--'}}</span>
                    </tooltip-content>
                  </template>
                </yxt-table-column>
                <yxt-table-column
                    :label="$t('pc_biz_ote_btn_operate' /* 操作 */)"
                    :width="groupId ? 254 : 90"
                > 
                    <template slot-scope="scope">
                        <yxt-button
                          v-if="groupId"
                          class="button-more"
                          @click.native.prevent="handelGroupLeader(scope.row.leader,scope.row.userId, groupId)"
                          type="text"
                          size="medium"
                        >
                            {{scope.row.leader ? $t('pc_biz_group_cancel_leader' /* 取消组长 */) : $t('pc_biz_group_set_leader' /* 设为组长 */)}}
                        </yxt-button>
                        <yxt-divider v-if="groupId" direction="vertical"></yxt-divider>
                        <yxt-button
                            v-if="groupId"
                            class="button-more"
                            @click.native.prevent="handleMoveGroupMember(scope.row.userId, groupId)"
                            type="text"
                            size="medium"
                        >
                            {{$t('pc_biz_group_remove_group' /* 移出小组 */)}}
                        </yxt-button>
                        <yxt-divider v-if="groupId && action" direction="vertical"></yxt-divider>
                        <yxt-button
                            v-if="action"
                            :class="{'button-more':!!groupId}"
                            @click.native.prevent="deleteUser([scope.row.userId])"
                            type="text"
                            size="medium"
                        >
                            {{$t('pc_biz_group_delete' /* 删除 */)}}
                        </yxt-button>
                        <span v-if="!groupId && !action">--</span>
                    </template>
                </yxt-table-column>
            </yxt-table>
        </div>
        <div class="group-member-content-pagination">
            <yxt-pagination
                class="pull-right"
                :page-size="limit"
                :total="memberList.length"
                :current-page="current"
                :page-count="totalPage"
                :show-on-single-page="false"
                @current-change="pageChange"
                layout="total, prev, pager, next"
            ></yxt-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { Button, Table, TableColumn, Pagination, Divider, Tag } from 'yxt-pc';
import TooltipContent from './tooltip-content.vue';
export default {
  components: {
    'yxt-Button': Button,
    'yxt-table': Table,
    'yxt-table-column': TableColumn,
    'yxt-pagination': Pagination,
    'yxt-divider': Divider,
    'yxt-tag': Tag,
    'tooltip-content': TooltipContent
  },
  props: {
    memberList: {
      type: Array,
      require: true
    },
    groupId: {
      type: String | Number,
      require: true
    },
    action: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    memberTableList() {
      const begin = this.current === 1 ? 0 : (this.current - 1) * this.limit;
      const end = this.current === 1 ? this.limit : this.current * this.limit;
      const tableList = this.memberList.slice(begin, end);

      return tableList.map(item=>{
        return {
          ...item,
          isSelected: false
        };
      });
    },
    totalPage() {
      return Math.ceil(this.memberList.length / this.limit);
    },
    memberIds() {
      return this.memberTableList.map(member=>member.userId);
    }
  },
  inject: {
    selectedUserIds: {
      value: {
        default: []
      }
    },
    setSelectUser: {
      default: () => {}
    },
    setGroupLeader: {
      default: () => {}
    },
    cancelGroupLeader: {
      default: () => {}
    },
    handleMoveGroupMember: {
      default: () => {}
    },
    deleteUser: {
      default: () => {}
    },
    addUser: {
      default: () => {}
    }
  },
  watch: {
    current() {
      this.setSelectedRow();
    },
    memberList() {
      if (this.memberTableList.length) {
        this.setSelectedRow();
      } else {
        this.current = 1;
      }
    },
    'selectedUserIds.value'() {
      if (this.selectedUserIds.value.length === 0) {
        this.$refs.refTable && this.$refs.refTable.clearSelection();
      }
    }
  },
  data() {
    return {
      limit: 20,
      current: 1
    };
  },
  mounted() {
    this.initSelectedRow();
  },
  methods: {
    getMemberTagClass(id) {
      console.log(id);
      const el = document.querySelector(`#${id}`);
      console.log(el);
      return 'group-member-content-list-tag';
    },
    positionNameFormatter(row) {
      return row.positionName || '--';
    },
    setSelectedRow() {
      this.memberTableList.forEach(item => {
        item.isSelected = this.selectedUserIds.value.includes(item.userId);
      });
    },
    initSelectedRow() {
      this.memberTableList.forEach(item => {
        if (this.selectedUserIds.value.includes(item.userId)) {
          this.$refs.refTable.toggleRowSelection(item, true);
        }
      });
    },
    pageChange(val) {
      this.current = val;
    },
    handleSelectionChange(users) {
      const otherUserIds = this.selectedUserIds.value.filter(id=>!this.memberIds.includes(id));
      const newUser = users.map(user=>user.userId);
      this.setSelectUser(otherUserIds.concat(newUser));
    },
    selectAll(users) {
      const otherUserIds = this.selectedUserIds.value.filter(id=>!this.memberIds.includes(id));
      const newUser = users.map(user=>user.userId);
      this.setSelectUser(otherUserIds.concat(newUser));
    },
    handelGroupLeader(leader, userId, groupId) {
      leader ? this.cancelGroupLeader(userId, groupId) : this.setGroupLeader(userId, groupId);
    }
  }
};
</script>
<style  lang="scss">
// .group-member {
//    ::-webkit-scrollbar-track-piece {
//      -webkit-border-radius: 0;
//      border-radius: 0;
//    }

//    ::-webkit-scrollbar {
//      width: 5px;
//      height: 10px;
//    }

//    ::-webkit-scrollbar-thumb {
//      height: 50px;
//      background-color: rgba(144,147,153,.3);
//      -webkit-border-radius: 6px;
//      border-radius: 6px;
//      outline-offset: -2px;
//      -moz-opacity: 0.5;
//      -khtml-opacity: 0.5;
//      opacity: 0.5;
//      filter: alpha(opacity = 50);
//    }

//    ::-webkit-scrollbar-thumb:hover {
//      height: 50px;
//      background-color: rgba(144,147,153,.7);
//      -webkit-border-radius: 6px;
//      border-radius: 6px;
//    }
// }
</style>
<style lang="scss" scoped>
.group-member{
    display: flex;
    flex-direction: column;
    height: 100%;
    
    &-header{
        padding-bottom: 16px;
    }
    &-content--full{
      height: 100%;
    }
    &-content{
        height: calc(100% - 48px);

        &-list{
            height: calc(100% - 48px);
            overflow: hidden;
            
            &__name{
              margin-right: 8px;
            }
            &-tag{
              display: flex;
              justify-content: space-between;
              align-items: center;
              /deep/ .yxt-open-value{
                width: 100%;
              }
            }
            &__drag{
              width: 17px;
              height: 16px;
              display: none;
              -webkit-user-drag: none;
            }
            .button-more{
              width: 60px;
              word-wrap: break-word;
              white-space: normal;
            }
           /deep/ .yxt-table::before{
            z-index: 10;
           }
            /deep/ .yxt-table__row{
              cursor: move;
              &:hover{
                > *{
                   background: #F0F6FF;
                }
                .group-member-content-list__drag{
                  display: inline-block;
                }
              }
            }
        }
        &-list--full{
          height: 100%;
           /deep/ .yxt-table::before{
             background: #fff;
           }
        }
        &-pagination{
            height: 42px;
            display: flex;
            align-content: flex-end;
            justify-content: flex-end;
            padding-top: 16px;
        }
    }
}
</style>
